import { FormHelperText, InputLabel } from '@mui/material';
import Select from '@mui/material/Select';
import { FormikValues } from 'formik';
import FormControl from '@mui/material/FormControl';
import { useState } from 'react';
import ItemChip from '../chips/ItemChip';
import { Epic } from '../../../model/epic';

type Props = {
	id: string;
	label?: string;
	size?: 'small' | 'medium';
	disabled?: boolean;
	required?: boolean;
	formik?: FormikValues;
	onClick?: () => void;
};

export default function InputEpicPopupSelect({
	id,
	label,
	size = 'medium',
	disabled = false,
	required = false,
	onClick,
	formik,
}: Props) {
	const [open, setOpen] = useState(false);
	const handleDelete = (objIdToDelete: number) => {
		formik?.setFieldValue(
			id,
			formik.values[id].filter((dept: Epic) => dept.id !== objIdToDelete),
		);
	};
	const handleRenderValue = (selected: Epic[]): React.ReactNode => {
		return (
			<div className='flex flex-wrap gap-2'>
				{selected.map(item => (
					<ItemChip
						key={item.id}
						text={item.name}
						disabled={disabled}
						onDelete={() => handleDelete(item.id)}
					/>
				))}
			</div>
		);
	};

	return (
		<div>
			<FormControl
				className='w-full relative text-m'
				size={size}
				error={formik?.touched[id] && formik?.errors[id] && true}
			>
				<InputLabel id={`${id}_label`} required={required}>
					{label}
				</InputLabel>
				<Select
					labelId={`${id}_label`}
					label={label}
					id={id}
					multiple
					value={formik?.values[id]}
					open={open}
					autoFocus={false}
					renderValue={handleRenderValue}
					disabled={disabled}
					onOpen={() => {
						if (onClick) onClick();
						setOpen(false);
					}}
				/>
				{formik?.touched[id] && formik?.errors[id] && (
					<FormHelperText classes={{ root: 'absolute bottom-0 translate-y-full' }} error>
						{formik?.errors[id]}
					</FormHelperText>
				)}
			</FormControl>
		</div>
	);
}
